<template>
  <div id="service-configuration" class="kp-flat-card small-shadow">
    <el-tabs v-model="activeTab">
      <el-tab-pane label="Payment Acceptance" name="payment-acceptance">
        <div class="row toggle-list" id="payments-toggles">
          <div class="col-lg-4 col-md-6" v-for="(payment, index) in paymentAcceptance" :key="index" :class="{selected: payment.selected}">
            <div class="toggle-service">
              <img :src="`./img/payments/${payment.model}.png`"  alt="">
              <span>{{ payment.name }}</span>
              <el-switch v-model="payment.selected" @change="handleMastercardModal($event, payment)"></el-switch>
            </div>
          </div>
        </div>
        <div class="text-right mt-20">
          <button class="btn" @click="activeTab = 'services'">Next</button>
        </div>
      </el-tab-pane>
      <el-tab-pane label="Services" name="services">
        <div class="row toggle-list" id="services-toggles">
          <div class="col-lg-4 col-md-6" v-for="(service, index) in filteredServices" :key="index" :class="{selected: service.selected}">
            <div class="toggle-service">
              <img :src="`./img/services/${service.model}.png`"  alt="">
              <span>{{ service.name }}</span>
              <el-switch v-model="service.selected" @change="handlePosModal($event, service)"></el-switch>
            </div>
          </div>
        </div>
        <div class="text-right mt-20">
          <button class="btn" @click="step = 3">Next</button>
        </div>
      </el-tab-pane>
      <!-- <el-tab-pane label="Banking" name="banking">
        <div class="row toggle-list" id="banking-toggles">
          <div class="col-lg-4 col-md-6" v-for="(banking, index) in bankings" :key="index" :class="{selected: banking.selected}">
            <div class="toggle-service">
              <img :src="`./img/banking/${banking.model}.png`"  alt="">
              <span>{{ banking.name }}</span>
              <el-switch v-model="banking.selected"></el-switch>
            </div>
          </div>
        </div>
        <div class="text-right mt-20">
          <button class="btn" @click="activeTab = 'apps'">Next</button>
        </div>
      </el-tab-pane>
      <el-tab-pane label="Apps" name="apps">
        <div class="row toggle-list" id="apps-toggles">
          <div class="col-lg-4 col-md-6" v-for="(app, index) in apps" :key="index" :class="{selected: app.selected}">
            <div class="toggle-service">
              <img :src="`./img/apps/${app.model}.png`"  alt="">
              <span>{{ app.name }}</span>
              <el-switch v-model="app.selected"></el-switch>
            </div>
          </div>
        </div>
        <div class="text-right mt-20">
          <button class="btn" @click="step = 3">Next</button>
        </div>
      </el-tab-pane> -->
    </el-tabs>

    <mastercard-modal></mastercard-modal>
    <pos-modal></pos-modal>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import PosModal from '@/components/modals/PosModal.vue'
import MastercardModal from '@/components/modals/MastercardModal.vue'

export default {
  name: 'service-configuration',
  components: {
    PosModal,
    MastercardModal
  },
  computed: {
    ...mapFields({
      user: 'user',
      company: 'company',
      step: 'registration.step',
      paymentAcceptance: 'paymentAcceptance',
      services: 'services',
      bankings: 'banking',
      apps: 'apps',
    }),
    filteredServices() {
      const filteredServices = this.services.filter(serv => serv.model !== 'terminal')
      return !this.company.salePoint ? filteredServices : this.services
    }
  },
  data() {
    return {
      activeTab: 'payment-acceptance',
      mastercardModalVisible: false,
      modalData: null
    };
  },
  methods: {
    handleMastercardModal(checked, service) {
      if (checked && service.model === 'mastercard') {
        this.$store.commit('updateMastercardField', false)
        this.$store.commit('showHideModal', {
          modal: 'MastercardModal',
          show: true
        })
      }
    },
    handlePosModal(checked, service) {
      if (checked && service.model === 'terminal') {
        this.$store.commit('updatePosField', false)
        this.$store.commit('showHideModal', {
          modal: 'PosModal',
          show: true
        })
      }
    }
  }
}
</script>
